import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { MaskedContactTypes } from '../Types';

const machine = Machines.onMaskedContact.machine;

export const getMaskedContact = (
  params: MaskedContactTypes.MaskedContactServiceRequestType,
): Promise<MaskedContactTypes.IMaskedContactServiceResponse> => {
  return callServiceMachine(machine, params);
};

export default { getMaskedContact };
